import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.bankValidation = function () {
    const dictonary = {
      custom: {
        BankCode: {
          required: () => t.t(dictEnum.LBL_BankCode) + t.t(dictEnum.WARN_IsRequired)
        },
        Cname: {
          required: () => t.t(dictEnum.LBL_CName) + t.t(dictEnum.WARN_IsRequired)
        },
        EName: {
          required: () => t.t(dictEnum.LBL_EName) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080900-Banks/S080900-BanksValidation.js